import { lazy, Suspense } from "react";
import {
  Routes,
  Route,
  BrowserRouter,
  type BrowserRouterProps,
} from "react-router";
import AdminLayout from "@/layouts/AdminLayout";
import MainLayout from "@/layouts/MainLayout";
import { AdminGuard } from "@/components/atom/AdminGuard";

const Home = lazy(() => import("@/pages/Home"));
const About = lazy(() => import("@/pages/About"));
const FAQ = lazy(() => import("@/pages/FAQ"));
const PrivateHouses = lazy(() => import("@/pages/PrivateHouses"));
const HighRiseBuildings = lazy(() => import("@/pages/HighRiseBuildings"));
const ProjectDetails = lazy(() => import("@/pages/ProjectDetails"));
const Renovations = lazy(() => import("@/pages/Renovations"));

// Admin Pages
const AdminDashboard = lazy(() => import("@/pages/admin/AdminDashboard"));
const FeaturesList = lazy(() => import("@/pages/admin/FeaturesList"));
const ProjectsList = lazy(() => import("@/pages/admin/ProjectsList"));
const AdminsList = lazy(() => import("@/pages/admin/AdminsList"));

// Auth Pages
const Login = lazy(() => import("@/pages/auth/Login"));
import { AuthGuard } from "@/components/atom/AuthGuard";

interface AppRoutesProps {
  Router?: React.ComponentType<BrowserRouterProps>;
}

export default function AppRoutes({ Router = BrowserRouter }: AppRoutesProps) {
  return (
    <Router>
      <Suspense fallback={<div className="h-screen w-full bg-white" />}>
        <Routes>
          <Route element={<MainLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/cottages" element={<PrivateHouses />} />
            <Route path="/buildings" element={<HighRiseBuildings />} />
            <Route path="/renovations" element={<Renovations />} />
            <Route path="/projects/:id" element={<ProjectDetails />} />
          </Route>

          {/* Auth Routes */}

          <Route path="/auth/login" element={<Login />} />

          {/* Admin Routes */}
          <Route element={<AuthGuard />}>
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="features" element={<FeaturesList />} />
              <Route path="projects" element={<ProjectsList />} />
              <Route path="admins" element={<AdminGuard><AdminsList /></AdminGuard>} />
            </Route>
          </Route>
        </Routes>
      </Suspense>
    </Router>
  );
}
